module.exports = __webpack_public_path__ + "img/cooperative0_logo11.c59210be.jpg";